import { PermissionDto, RoleDto } from '@clearing-hub/common';

export class ChangeApplicationPayload {
  roles: Array<RoleDto>;
  permissions: Array<PermissionDto>;

  constructor(roles: Array<RoleDto>, permissions: Array<PermissionDto>) {
    this.roles = roles;
    this.permissions = permissions;
  }
}
